import React, { useState } from 'react'
import _ from 'lodash'
import { Input, Button } from 'antd'
import { SketchPicker, ColorResult } from 'react-color'
import styled from 'styled-components/macro'

import { useDispatch, useSelector } from 'react-redux'
import { Label } from '../Page/Layout'
import { selectedTheme } from '../../features/theme/selectors'
import { ThemeActions } from '../../features/theme/actions'

const StyledButton = styled(Button)<{ bg: string }>`
  background-color: ${({ bg }) => bg};
`

const Popover = styled.div`
  position: absolute;
  z-index: 2;
`

const Cover = styled.div`
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
`

const ColorPickerWrapper = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;

  .picker-input {
    width: 80px;
    border-radius: 0;
    input {
      border-radius: 8px 0px 0px 8px;
    }
  }

  .picker-button {
    align-self: flex-end;
    width: 90px;
    button {
      border-radius: 0px 8px 8px 0;
      padding: 5px 8px;
    }
  }
`

type Props = {
  field: string
  label: string
}

export const ColorPicker = ({ label, field }: Props) => {
  const [viewPicker, setViewPicker] = useState(false)
  const dispatch = useDispatch()
  const theme = useSelector(selectedTheme)

  const color = _.get(theme, field)

  const changeColor = async (col: ColorResult) => {
    if (col !== null) {
      const themeToValidate = { ...theme, [field]: col.hex }
      dispatch(ThemeActions.updateNewTheme(themeToValidate))
    }
  }

  return (
    <>
      <Label>{label}</Label>
      <ColorPickerWrapper>
        <div className="picker-input">
          <Input placeholder="#" value={color} />
        </div>

        <div className="picker-button">
          <StyledButton bg={color} onClick={() => setViewPicker(!viewPicker)}>
            Cambia
          </StyledButton>
          {viewPicker && (
            <Popover>
              <Cover onClick={() => setViewPicker(!viewPicker)} />
              <SketchPicker color={color || undefined} onChangeComplete={changeColor} />
            </Popover>
          )}
        </div>
      </ColorPickerWrapper>
    </>
  )
}
